import Spec from "../../specs/Spec";
import { SpecManager } from "../../specs/SpecManager";
import { BundleBase } from "../BundleBase";
import ConsistencyCheck from "./ConsistencyCheck";

export default class ConsistencyChecksManager extends SpecManager {
    fields: { [key: string]: ConsistencyCheck } = {};

    radicals: { [key: string]: number}

    constructor(public bundleBase:BundleBase, public rules: { [key: string]: any }, radicals: { [key: string]: number}) {
        super(rules, false, {});
        // this.bundleBase =bundleBase
        this.radicals = radicals
        this.listFields = Object.keys(rules)
        this.initializeFields()
        this.fillSpecs(this.bundleBase.specs)
    }

    showAllConsistencyChecks: boolean = false

    get name() {
        return "CONSISTENCY"
    }

    get filteredChecks() {
        if (!this.showAllConsistencyChecks) {
            let checksToValidate = {}
            for (const [key, value] of Object.entries(this.fields)) {
                if (key.startsWith("check") && !value.isValid) {
                    checksToValidate[key] = value
                }
            }
            return checksToValidate
        }
        return this.fields
    }

    get allChecksValid() {
        for (const key of Object.keys(this.fields)) {
            if (key.startsWith("check") && !this.fields[key].isValid) {
                return false
            }
        }
        return true
    }

    initializeField(key: string) {
        this.addFromDependency(key)

        let listControl
        if (this.rules[key].listControl) {
            if (this.rules[key].listControl?.length) {
                listControl = {}
                let index = 1
                for(const check of this.rules[key].listControl) {
                    listControl[`check${index}`] = check
                    index++
                }
            } else {
                listControl = this.rules[key].listControl
                console.error("listControl is not a list")
            }
        }
        const cc = new ConsistencyCheck(
            key,
            this.rules[key].function,
            this,
            this.rules[key].label,
            this.rules[key].level,
            this.rules[key].textError,
            listControl
        );
        this.dependencies[key] = Spec.getDependencies(this.rules[key].function)
        return cc
    }

    getChecks() {
        return this.fields
    }

    afterUpdate() {
    }
}
